import { environment } from 'src/environments/environment';

import { Component } from '@angular/core';

@Component({
	selector: 'app-policy-footer',
	templateUrl: './policy-footer.component.html',
	styleUrls: ['./policy-footer.component.scss'],
	imports: [],
})
export class PolicyFooterComponent {
	termsAndConditionsUrl = environment.termsAndConditionsUrl;
	privacyPolicyUrl = environment.privacyPolicyUrl;
}
